<template>
  <footer>
    <p>北京艾西智酷科技有限公司 | Copyright ©2021 minisek.com | 京ICP备19032638号-4</p>
    <p>地址 : 北京市海淀区丰豪东路9号 | 联系邮箱：fengguoqiang@iczhiku.com | 电话：18610269133（工作日9:00-18:00）</p>
  </footer>
</template>

<script>
export default {
  name: "footers"
};
</script>
<style scoped>
footer {
  background-color: rgb(255, 255, 255);
  width: 100%;
  min-width: 1200px;
  height: 114px;
  font-size: 14px;
  color: #333;
  line-height: 30px;
  padding-top: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/footer.vue